import { Dialog, DialogActions, DialogContent, Slide } from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { closeCenterModal } from "store/slices/CenterModal.slice";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const CenterModal = () => {
  const {
    isOpen,
    actions,
    content,
    fullScreen,
    maxWidth = "500px",
    disableClose,
  } = useSelector((state) => state.centerModal);
  const dispatch = useDispatch();

  const onClose = () => {
    if (disableClose) return;
    dispatch(closeCenterModal());
  };

  useEffect(() => {
    if (!isOpen) return;

    const handleEscape = (e) => {
      if (e.key !== "Escape") return;
      if (disableClose) return;
      // don't close if a menu/popover/select dropdown is open on top
      if (
        e.target?.closest?.(
          '[role="menu"], [role="listbox"], .MuiMenu-root, .MuiPopover-root',
        )
      )
        return;
      e.stopPropagation();
      dispatch(closeCenterModal());
    };

    window.addEventListener("keydown", handleEscape);
    return () => window.removeEventListener("keydown", handleEscape);
  }, [disableClose, dispatch, isOpen]);

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      fullScreen={fullScreen}
      sx={{
        "& .MuiDialog-paper": {
          width: "100%",
          maxWidth: maxWidth || "500px",
          backgroundImage: "none",
          boxShadow: "none",
          borderRadius: "32px",
          margin: { sm: "20px" },
        },
      }}
      TransitionComponent={Transition}
      className="centerModel"
    >
      <DialogContent className="no-scrollbar" sx={{ p: "0" }}>
        {content}
      </DialogContent>
      {actions && <DialogActions>{actions}</DialogActions>}
    </Dialog>
  );
};

export default CenterModal;
